<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  let platFromList= [{value: "Android", key: "Android"}, {value: "IOS", key: "IOS"}, {value: "H5", key: "H5"}];//适用平台
  let termList=[{value: "未开始", key: "1"}, {value: "有效", key: "2"}, {value: "已结束", key: "3"}];//有效期
  let accountTypeList= [{value: "模拟", key: "2"}, {value: "真实", key: "3"}, {value: "游客", key: "1"}];//适用用户
  let isActiveList=[{value: "未激活", key: "1"}, {value: "已激活", key: "2"}];//激活状态
  let userLevel=[{value: "迷你VN", key: "MIN"}, {value: "标准VN", key: "STD"}, {value: "铂金VN", key: "PLA"}, {value: "巴菲特VN", key: "ZER"},{value: "迷你IN", key: "MIN2"}, {value: "标准IN", key: "STD2"}, {value: "铂金IN", key: "PLA2"},];//账户等级
  let position=[];//广告位置
  let category=[];
  let languageList={"ZH_CN":"ZH_CN","VI_VN":"VI_VN","EN_US":"EN_US","HI_IN":"HI_IN","zh_TW":"zh_TW"};//语言
  let positionType={"1":"图片","2":"文字"}
  let nationality={"ISO_3166_704":"越南","ISO_3166_356":"印度"}
  let channeList=[];//
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
          if(clickName =="delete"){
              this.$confirm(window.$t("common.ifDelete"), window.$t("common.tip"), {
                  distinguishCancelAndClose: true,
                  confirmButtonText: window.$t("common.ok"),
                  cancelButtonText: window.$t("common.canceld")
              }).then(() => {
                  this.$axios.get(URL.advertising.del+"?id="+row.id).then(res=> {
                      if (res.code == 0) {
                          this.$message.success("suc");
                          this.$refs.childTable.defaultGetData(this.queryData);
                      }
                  });
                  })

          }else if (clickName == "update"){
            let rowStr=JSON.parse(JSON.stringify(row));
            let updRow=JSON.parse(row.adverInfo);
              rowStr.time=[];
              rowStr.param1=[];
              rowStr.param2=[];
            if(typeof rowStr.channel =="string"){
              if(rowStr.channel.indexOf(",")!=-1){
                  rowStr.channel=rowStr.channel.split(",");
              }else{
                   let channel1=[];
                   channel1.push(rowStr.channel);
                  rowStr.channel=channel1;
              }
            }
            if(typeof rowStr.userLevel =="string") {
                if (rowStr.userLevel.indexOf(",") != -1) {
                    rowStr.userLevel = rowStr.userLevel.split(",");
                } else {
                    let userLevel1 = [];
                    userLevel1.push(rowStr.userLevel);
                    rowStr.userLevel = userLevel1;
                }
            }
            if(typeof rowStr.nationality =="string") {
              if (rowStr.nationality.indexOf(",") != -1) {
                rowStr.nationality = rowStr.nationality.split(",");
              } else {
                let nationality1 = [];
                nationality1.push(rowStr.nationality);
                rowStr.nationality = nationality1;
              }
            }
            if(typeof rowStr.isActive =="string") {
                if (rowStr.isActive.indexOf(",") != -1) {
                    rowStr.isActive = rowStr.isActive.split(",");
                } else {
                    let isActive1 = [];
                    isActive1.push(rowStr.isActive);
                    rowStr.isActive = isActive1;
                }
            }
            if(typeof rowStr.platform =="string") {
                if (rowStr.platform.indexOf(",") != -1) {
                    rowStr.platform = rowStr.platform.split(",");
                } else {
                    let platform1 = [];
                    platform1.push(rowStr.platform);
                    rowStr.platform = platform1;
                }
            }
            if(typeof rowStr.language =="string") {
                  if (rowStr.language.indexOf(",") != -1) {
                      rowStr.language = rowStr.language.split(",");
                  } else {
                      let language1 = [];
                      language1.push(rowStr.language);
                      rowStr.language = language1;
                  }
              }
            if(typeof rowStr.accountType =="string") {
                if (rowStr.accountType.indexOf(",") != -1) {
                    rowStr.accountType = rowStr.accountType.split(",");
                } else {
                    let accountType1 = [];
                    accountType1.push(rowStr.accountType);
                    rowStr.accountType = accountType1;
                }
            }
              rowStr.sort=updRow.sort;
              rowStr.positionType=parseInt(updRow.adType);
              rowStr.url=updRow.imgUrl;
              rowStr.address=updRow.linkUrl;
              rowStr.title=updRow.title;
              rowStr.content=updRow.content;
              rowStr.time.push(rowStr.startTime);
              rowStr.time.push(rowStr.endTime);
            if(rowStr.aboutType.indexOf("2")!=-1){
                rowStr.param1.push(2);
            }
            if(rowStr.aboutType.indexOf("3")!=-1){
                rowStr.param1.push(1);
            }
            if(rowStr.aboutType.indexOf("4")!=-1){
                rowStr.param2.push(2);
            }
            if(rowStr.aboutType.indexOf("5")!=-1){
                rowStr.param2.push(1);
            }
          this.$refs.childUpdate.open(rowStr);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t("common.search") == clickName ){
          data.language1=data.language;
          delete(data["language"]);
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName || window.$t("common.addNew") == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
          console.log(model);
          if(!model.positionType){
              model.positionType=1;
          }
          if(model.title==null || model.title==undefined || model.title==''){
              model.title='';
          }
        //根据是否包含id更新还是添加
          let adverInfo={"sort":model.sort,"adType":model.positionType,"imgUrl":model.url,"linkUrl":model.address,"title":model.title,"content":model.content}
          model.adverInfo=JSON.stringify(adverInfo);
          console.log(adverInfo,model);
          if(model.channel==null || model.channel==undefined || model.channel==''){
              model.channel='';
          }else if(model.channel.length>1){
             model.channel= model.channel.join(",");
          }else{
              model.channel=model.channel[0]+"";
          }
          if(model.userLevel==null || model.userLevel==undefined || model.userLevel==''){
              model.userLevel='';
          }else if(model.userLevel.length>1){
             model.userLevel=model.userLevel.join(",");
          }else{
              model.userLevel=model.userLevel[0]+"";
          }

          if(model.nationality.length>1){
            model.nationality=model.nationality.join(",");
          }else{
            model.nationality=model.nationality.toString();
          }

          if(model.isActive.length>1){
             model.isActive=model.isActive.join(",");
          }else{
              model.isActive=model.isActive.toString();
          }
          if(model.time!=undefined && model.time.length>1){
            model.endTime=model.time[1];
            model.startTime=model.time[0];
          }
          if(model.platform.length>1){
            model.platform=model.platform.join(",");
          }else{
              model.platform=model.platform.toString();
          }
          if(model.language.length>1){
              model.language1=model.language.join(",");
          }else{
              model.language1=model.language.toString();
          }
          if(model.accountType.length>1){
             model.accountType=model.accountType.join(",");
          }else{
              model.accountType=model.accountType.toString();
          }
          model.aboutType='';
          //模拟
          for(let i in model.param1){
              if(model.param1[i]==1){
                  //未转换
                  model.aboutType+="3,";
              }else if(model.param1[i]==2){
                  //有转换
                  model.aboutType+="2,";
              }
          }
          //真实
          for(let i in model.param2){
              if(model.param2[i]==1){
                  //未转换
                  model.aboutType+="5,";
              }else if(model.param2[i]==2){
                  //有转换
                  model.aboutType+="4,";
              }
          }
          model.aboutType=model.aboutType.substring(0,model.aboutType.lastIndexOf(","));
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.advertising.edit:URL.advertising.save,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
          this.$refs.childTable.
          defaultGetData(this.queryData);
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},

        /*新增或更新*/
        updateData:{
          cols:[
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: window.$t("txmis.advertising.name"), field: 'name'},
                          { title: window.$t("txmis.advertising.platform"), field: 'platform',type:2,optionList:platFromList},
                          { title: window.$t("txmis.advertising.term"), field: 'term'},
                          { title: window.$t("txmis.advertising.accountType"), field: 'accountType'},
                          { title: window.$t("txmis.advertising.isActive"), field: 'isActive'},
                          { title: window.$t("txmis.advertising.userLevel"), field: 'userLevel'},
                          { title: window.$t("txmis.advertising.aboutType"), field: 'aboutType'},
                          { title: window.$t("txmis.advertising.position"), field: 'position'},
                          { title: window.$t("txmis.advertising.channel"), field: 'channel'},
                          { title: window.$t("txmis.advertising.language"), field: 'language',type:2,optionList:languageList},
                          {click:window.$t("common.search")},
                          {click:window.$t("common.addNew"),auth:"sys:advertising:save"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.advertising.query, //请求路径和参数
          //selection: true,
          sequence: true,
          cols: [
              {title:'id',field:'id',hidden:true},
              { title: window.$t("txmis.advertising.name"), field: 'name'},
              { title: window.$t("txmis.advertising.position"), field: 'position',render:(data)=>{
                  for (let i in position){
                    if(position[i].key == data){
                      return position[i].value;
                    }
                  }
                  return '';
                }},

              { title: window.$t("txmis.advertising.language"), field: 'language'},
              { title: window.$t("txmis.activeTemplate.img"), field: 'adverInfo',render:(data,full)=>{
                let adverInfo=JSON.parse(data);
                return adverInfo.imgUrl?("<img width='150px' height='50px' src='"+adverInfo.imgUrl+"'>"):"";
              },width:150},
              { title: window.$t("txmis.advertising.startTime"), field: 'startTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: window.$t("txmis.advertising.endTime"), field: 'endTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
              { title:  window.$t("txmis.advertising.adverInfo"), field: 'adverInfo',render:(data,full)=>{
                let adverInfo=JSON.parse(data);
                return adverInfo.linkUrl || "";
              }},
              { title: window.$t("txmis.advertising.platform"), field: 'platform'},
              { title: window.$t("txmis.advertising.channel"), field: 'channel'},
              { title: window.$t("txmis.advertising.accountType"), field: 'accountType',render:(data)=>{
                  if(data.indexOf(",")!=-1){
                      let temp=data.split(",");
                      let str="";
                      for (let i in temp){
                          for (let j in accountTypeList){
                              if(accountTypeList[j].key == temp[i]){
                                  str += accountTypeList[j].value+",";
                              }
                          }
                      }
                      return  str.substring(0,str.lastIndexOf(","));
                  }else{
                      for (let j in accountTypeList){
                          if(accountTypeList[j].key == data){
                              return accountTypeList[j].value;
                          }
                      }
                  }
                  }},
              { title: window.$t("txmis.advertising.userLevel"), field: 'userLevel'},
              { title: window.$t("txmis.advertising.isActive"), field: 'isActive',render:(data)=>{
                  if(data.indexOf(",")!=-1){
                      let temp=data.split(",");
                      let str="";
                      for (let i in temp){
                          for (let j in isActiveList){
                              if(isActiveList[j].key == temp[i]){
                                  str += isActiveList[j].value+",";
                              }
                          }
                      }
                      return  str.substring(0,str.lastIndexOf(","));
                  }else{
                      for (let j in isActiveList){
                          if(isActiveList[j].key == data){
                              return isActiveList[j].value;
                          }
                      }
                  }
                  }},
              { title: window.$t("txmis.advertising.nationality"), field: 'nationality',render:(data,full)=> {
                if (!data || data == ""){
                  return "";
                }else if (data.indexOf(",")!=-1){
                  let temp = data.split(",");
                  let strData = [];
                  for (let i in temp){
                    strData.push(nationality[temp[i]] + ",");
                  }
                  return strData.join(",");
                }else{
                  return nationality[data];
                }
              }},
             { title: window.$t("txmis.advertising.status"), field: 'status',render:(data)=>{
                if(data == 1)
                  return window.$t("common.start");
                return window.$t("common.stop");
              }},

              { title: window.$t("txmis.advertising.createTime"), field: 'createDate',render:(data)=>{
                      if(data)
                          return  DateUtil.getZoneTime(16,data);
                      return data;
                  }},
              { title: window.$t("txmis.advertising.updateTime"), field: 'updateDate',render:(data)=>{
                      if(data)
                          return  DateUtil.getZoneTime(16,data);
                      return data;
                  }},
              {title:window.$t("common.handle"),width:200,btnClick:[{name:window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete",auth:"sys:advertising:delete"},{name:window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit",auth:"sys:advertising:edit"}]},

          ]
        }
      }
    },
      created(){
          this.$axios.get(URL.advertising.getData).then(res=>{
              if(res.code==0){
                 position=res.result.position;
                 category=res.result.positionType;
                 channeList=res.result.dfre;
                  this.formData.cols =[
                      { title: window.$t("txmis.advertising.name"), field: 'name'},
                      { title: window.$t("txmis.advertising.platform"), field: 'platform',type:2,optionList:platFromList},
                      { title: window.$t("txmis.advertising.term"), field: 'term',type:2,optionList:termList},
                      { title: window.$t("txmis.advertising.accountType"), field: 'accountType',type:2,optionList:accountTypeList},
                      { title: window.$t("txmis.advertising.isActive"), field: 'isActive',type:2,optionList:isActiveList},
                      { title: window.$t("txmis.advertising.userLevel"), field: 'userLevel',type:2,optionList:userLevel},
                      //{ title: window.$t("txmis.advertising.aboutType"), field: 'aboutType',type:2,optionList:change},
                      { title: window.$t("txmis.advertising.position"), field: 'position',type:2,optionList:position},
                      { title: window.$t("txmis.advertising.channel"), field: 'channel',type:2,optionList:channeList},
                      { title: window.$t("txmis.advertising.language"), field: 'language',type:2,optionList:languageList},
                      { title: window.$t("txmis.advertising.nationality"), field: 'nationality',type:2,optionList:nationality},
                      {click:window.$t("common.search"),auth:"sys:advertising:view"},
                      {click:window.$t("common.addNew"),auth:"sys:advertising:save"}
                  ];
                  this.updateData.cols=[
                      {title:'id',field:'id',hidden:true},
                      { title:window.$t("txmis.advertising.name"), field: 'name'},
                      { title: window.$t("txmis.advertising.channel"), field: 'channel',type:4,optionList:channeList,data:[],hasCheckAll:true,checkAll:false},
                      { title: window.$t("txmis.advertising.language"), field: 'language',type:4,optionList:languageList,data:[],hasCheckAll:true,checkAll:false},
                      { title: window.$t("txmis.advertising.term"), field: 'time',type:9,data:[]},
                      { title: window.$t("txmis.advertising.accountType"), field: 'accountType',type:4,optionList:accountTypeList,data:[],hasCheckAll:true,checkAll:false},
                      /*{ title: window.$t("txmis.advertising.param"), field: 'param1',type:4,optionList:changeStatusList,data:[],hasCheckAll:true,checkAll:false,checkAllName:window.$t("txmis.advertising.simulation"),isNumber:true},
                      { title: '', field: 'param2',type:4,optionList:changeStatusList,data:[],hasCheckAll:true,checkAll:false,checkAllName:window.$t("txmis.advertising.real"),isNumber:true},*/
                      { title: window.$t("txmis.advertising.isActive"), field: 'isActive',type:4,optionList:isActiveList,data:[],hasCheckAll:true,checkAll:false},
                      { title: window.$t("txmis.advertising.userLevel"), field: 'userLevel',type:4,optionList:userLevel,data:[],hasCheckAll:true,checkAll:false},
                      { title: window.$t("txmis.advertising.nationality"), field: 'nationality',type:4,optionList:nationality,data:[],hasCheckAll:true,checkAll:false},
                      { title: window.$t("txmis.advertising.platform"), field: 'platform',type:4,optionList:platFromList,data:[],hasCheckAll:true,checkAll:false},
                      { title: window.$t("txmis.advertising.position"), field: 'position',type:2,optionList:position,isNumber:true},
                      { title: window.$t("txmis.advertising.positionType"), field: 'positionType',type:12,readonly:true,dataRender:(model,col)=>{
                        let position=model.position;
                        const index = category.findIndex(d => d.key == position);
                        if(index>=0) {
                            let obj = category[index];
                            this.$set(col, "data", obj.value);
                        }
                      }},
                      { title: window.$t("txmis.advertising.url"), field: 'url',upload:true},
                      { title: window.$t("txmis.advertising.title"), field: 'title',type:12,data:"活动详情",dataRender:(model,col)=>{
                            let language=model.language;
                            if (col.data != "") {
                                if (language.length >= 1) {
                                    if (language[0] == 'ZH_CN') {
                                        if (col.data == 'Chi tiết chương trình' || col.data == 'Terms and Conditions'){
                                            this.$set(col, "data",'活动详情')
                                        }
                                    }else if (language[0] == 'VI_VN') {
                                        if (col.data == '活动详情' || col.data == 'Terms and Conditions'){
                                            this.$set(col, "data",'Chi tiết chương trình')
                                        }
                                    }if (language[0] == 'EN_US') {
                                        if (col.data == 'Chi tiết chương trình' || col.data == '活动详情'){
                                            this.$set(col, "data",'Terms and Conditions')
                                        }
                                    }
                                }
                            }
                          }},
                      { title: window.$t("txmis.advertising.address"), field: 'address'},
                      { title: window.$t("txmis.advertising.content"), field: 'content',textType:"textarea"},
                      { title: window.$t("txmis.advertising.sort"), field: 'sort',type:7,data:0}
                  ]
              }
          });

      }
  }
</script>
